import { render, staticRenderFns } from "./vMadeWithMovement.vue?vue&type=template&id=3dbc1b1e&scoped=true"
import script from "./vMadeWithMovement.vue?vue&type=script&lang=js"
export * from "./vMadeWithMovement.vue?vue&type=script&lang=js"
import style0 from "./vMadeWithMovement.vue?vue&type=style&index=0&id=3dbc1b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc1b1e",
  null
  
)

export default component.exports